import { useTheme } from '@mui/material';
import { hexToRGBA } from '@stack/helpers';
import { useBackgroundColor } from '@stack/theme';

import { ColorsType } from './props';

/**
 * hooks to get timeline dot variant styles
 */
export const useTimelineDotVariantStyles = () => {
  const theme = useTheme();
  const background = useBackgroundColor();

  const colors: ColorsType = {
    primary: {
      boxShadow: 'none',
      color: theme.palette.primary.main,
      backgroundColor: background.primaryLight.backgroundColor,
    },
    secondary: {
      boxShadow: 'none',
      color: theme.palette.secondary.main,
      backgroundColor: background.secondaryLight.backgroundColor,
    },
    success: {
      boxShadow: 'none',
      color: theme.palette.success.main,
      backgroundColor: background.successLight.backgroundColor,
    },
    error: {
      boxShadow: 'none',
      color: theme.palette.error.main,
      backgroundColor: background.errorLight.backgroundColor,
    },
    warning: {
      boxShadow: 'none',
      color: theme.palette.warning.main,
      backgroundColor: background.warningLight.backgroundColor,
    },
    info: {
      boxShadow: 'none',
      color: theme.palette.info.main,
      backgroundColor: background.infoLight.backgroundColor,
    },
    grey: {
      boxShadow: 'none',
      color: theme.palette.grey[500],
      backgroundColor: hexToRGBA(theme.palette.grey[500], 0.12),
    },
  };

  return colors;
};
